import { LayoutProps, rankWith, uiTypeIs } from "@jsonforms/core";
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from "@jsonforms/react";
import { useQParam } from "../../../../../hooks/useQParam";
import { getElements } from "../../../../../utils/DynamicForms";
import { useDynamicFormContext } from "../../../DynamicFormContext";
import "./style.scss";
import { SheildIcon } from "../../../../../icons/truWeb-icons";

type Props = LayoutProps;

const QuotesLayout = (props: Props) => {
  const { formData } = useDynamicFormContext();
  const quoteId = useQParam("quote-id");
  const getElementByType = (type: string) =>
    getElements(props.uischema).find((el) => el.type === type) || ({} as any);

  if (!props.visible) return null;

  if (!formData?.quoteHasPremium) {
    return (
      <div className="tru-list-loading">
        <span className="loading-anim"></span>
      </div>
    );
  }

  return (
    <div className="tru-layout-pricing">
      <div className="layout-info-and-prices-comparison">
        <h5 className="title">
          {quoteId ? "Just a few more questions!" : "Here is Your Quote!"}{" "}
        </h5>
        <div className="prices-comparison">
          {formData?.quotes.map((quote: any) => {
            return (
              <div className="price-info" key={quote.id}>
                <div className="premium-icon">
                  {quoteId && <SheildIcon />}
                  <p>
                    <span className="month-quote">
                      ${quote?.premium && (quote?.premium / 12)?.toFixed(2)}
                      <span className="sub">/ month (Est.)</span>
                    </span>
                    <span className="year-quote">
                      ${quote.premium && quote.premium} / year{" "}
                    </span>
                  </p>
                </div>
                <div className="quote-actions">
                  {!quoteId && (
                    <ResolvedJsonFormsDispatch
                      {...props}
                      uischema={getElementByType("QuoteActionsLayout")}
                      cells={[quote.id]}
                    />
                  )}
                </div>
              </div>
            );
          })}
          <div className="quote-finalstep quote-actions">
            {quoteId ? (
              <ResolvedJsonFormsDispatch
                {...props}
                uischema={getElementByType("PurchaseLayout")}
              />
            ) : (
              <ResolvedJsonFormsDispatch
                {...props}
                uischema={getElementByType("QuotesCoveragesLayout")}
              />
            )}
          </div>
          {!quoteId && (
            <p className="quotes-description">
              {formData?.motorcycle?.M_Is_Higher_Or_Lower_37_Percent
                ? "Additional fees and/or taxes may apply. The premium amounts shown above are estimates based on the information you have provided. This offer is neither an acceptance of insurance nor a guarantee of insurability. you must speak to one of our licensed insurance representatives."
                : "Additional fees and/or taxes may apply. The premium amounts shown above are estimates based on the information you have provided. This offer is neither an acceptance of insurance nor a guarantee of insurability."}
            </p>
          )}
        </div>
        {!quoteId && (
          <div className="quote-btns">
            <ResolvedJsonFormsDispatch
              {...props}
              uischema={getElementByType("HorizontalFieldsActions")}
              cells={[formData?.quotes?.[0]?.id]}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export const QuotesLayoutEntry = {
  tester: rankWith(1, uiTypeIs("QuotesLayout")),
  renderer: withJsonFormsLayoutProps(QuotesLayout),
};
